<template>
    <section class="home-list pdb">
        <header class="headerCom" v-if="!hideHeaderCom">
            <img class="back" src="/images/public/back.png" @click='back'>
            <div class="location">
                <span class="f26">所有养护方案均以实物诊断为准</span>
            </div>
        </header>
        <section :class="{'swiper': true, 'mgt20': hideHeaderCom} ">
            
            <img class="back" src="/images/newIndex/list_top.png" @click="toScope()">
        </section>
        <section class="service_list">
            <div class='list_menu' :class='{fixed:contentFixed && !hideHeaderCom, "fixed-top0": contentFixed && hideHeaderCom}'>
                <ul>
                    <li v-for='(item,index) in serviceList' @click='clickTab(index)' :class='{active:active == index}' :key='index'>
                        <span></span>
                    
                        {{item.showFrontDeskClassify}}
                        <!-- <img src='/images/home/hotIcon_1.png' v-if='key == "activity"'> -->
                    </li>
                </ul>
            </div>
            <div class='list_content' :class='{ml186:contentFixed}'>
                <div v-for='(item,index) in serviceList' :key='index'>
                    <div class='list_title' :ref='index + "list"'>{{item.showFrontDeskClassify}}</div>
                    <div class='list_item'>
                        <list-item-new v-for='(data,dataIndex) in item.curingServiceGoodsWithPriceBoList' :service='data' :key='dataIndex' style='margin-bottom:20px' @select='select' :class='{num0:dataIndex==0}'/>
                    </div>
                </div>
            </div>
        </section>
        <div class="g-fixed-bottom" v-if='bagitNum.buyQuantity'>
            <div  @click='toHomebag(1)'>
                <div class='bagit_cont'>
                    <img src="/images/home/gouwu_icon.png" align="middle"/>
                    <p>方案</p>
                    <span class='bagit' v-if='bagitNum.buyQuantity'>{{bagitNum.buyQuantity}}</span>
                </div>
                <div class='price' v-if='bagitNum.orderAmount'>¥{{bagitNum.orderAmount}}</div>
            </div>
            <div class='flex_end'>
                <!-- <button class="secondary" v-show='specificationsShow'>加入方案</button> -->
                
                <button class="primary" @click='toHomebag(2)' :disabled='!bagitNum.buyQuantity'>确认方案</button>
            </div>
        </div>
        <!-- <div class="kefu-fix" :class="{scrolling:scrollFlag}">
                <div style="float:left;width:70%;margin-top:40px">
                    <div class="kefu-dis asc-line" v-if="isTis">
                       <span> 有任何不明白的地方就来问我吧</span>
                    </div>
                </div>
                <div style="float:right;width:20%;padding-left: 10px;" ref="shopBag" :class="{scrollTrueClass:scrollTrue}">
                    <div  id="alldo" style="position:absolute;width:150px;height:150px;z-index:999;">
                    </div>
                    <img src="/images/home/kefu-1.png" style="width:42px;height:48px;position:absolute;margin-top:10px;margin-left:3px" class="kefu-baoblack" alt="">
                    <img src="/images/home/kefu-2.png" style="width:56px;height:31px;position:absolute;margin-top: 43px;" class="kefu-ad" alt="">
                </div>
        </div> -->
        <van-popup position="bottom" v-model="specificationsShow" overlay-class='layer'>
            <div class="containerExpree f28">
                <div class="title">{{detail.name}}</div>

                <div class="close" @click="specificationsShow = false"></div>
                <div class='detail_content'>
                    <img :src="specificationList[selectSpecificationIndex].curingServiceImagesBoList[0]['pic'] | formatImgUrl(500,500,true)" class='detail_img'/>
                    <span class='teamTips' v-if='showGroupMemberNum'>{{showGroupMemberNum}}人团</span>
                    <div>
                        <div>
                            <div class='detail_price'>¥{{specificationList[selectSpecificationIndex].price}}</div>
                            <div class='detail_sail'>{{detail.content}}</div>
                        </div>
                        <div class='fr' v-if='specificationList[selectSpecificationIndex].classify == 10'>
                            <num-count
                                :num='servceNum'
                                @plus='servceNum++'
                                @minus='servceNum > 1 ? servceNum-- : servceNum = 1'
                            />
                        </div>
                    </div>
                </div>
                <div class='detail_title'>
                    规格
                </div>
                <div class="specification">
                    <ul>
                        <li v-for="(item,index) in specificationList"
                            :key="index"
                            :class="{'active':selectSpecificationIndex === index}"
                            @click="setIndex(index,item.name)">{{item.name}}</li>
                    </ul>
                </div>
                <div class="g-fixed-bottom">
                    <div>
                        <div class='bagit_cont' @click='toHomebag(3)'>
                            <img src="/images/home/gouwu_icon.png" align="middle"/>
                            <p>方案</p>
                            <span class='bagit' v-if='bagitNum.buyQuantity'>{{bagitNum.buyQuantity}}</span>
                        </div>
                        <div class='price' v-if='bagitNum.buyAmount'>¥{{bagitNum.buyAmount}}</div>
                    </div>
                    <div  class='flex_end'>
                        <button class="primary" @click='addBag' v-if='specificationList[selectSpecificationIndex].classify == 10'>加入方案</button>
                        <button class="primary" @click='addBag' v-if='specificationList[selectSpecificationIndex].classify == 30' :disabled='specificationList[selectSpecificationIndex].groupActivityBo.status != 20' :class='{disableBtn:!canTeam}'>发起拼团</button>
                        <button class="primary" @click='addBag' v-if='specificationList[selectSpecificationIndex].classify == 20'>立即购买</button>
                    </div>
                </div>
            </div>
        </van-popup>
    </section>
</template>

<script>
    import homeApi from '@/axios/home'
    import banner from './swiper/banner.jpg'
    import banner1 from './swiper/banner1.jpg'
    import $ from 'jquery'
    import { Toast } from 'vant';
    import { scrollAnimation } from '@/assets/js/scrollAnimate';
    import zhugeObj from '@/assets/js/track'
    import publicObj from '@/assets/js/public'
    import { setTimeout } from 'timers';
    import getWXConfig from "@/assets/js/wx.config";
    var timerout;
    export default {
        name: 'index',
        data () {
        const { hideHeaderCom } = this.$route.params
        return {
            showGroupMemberNum : '',
            serviceList : {
     
            },
            bannerList: [
                {
                    pic : banner1,
                    path : 'vipRecharge'
                },
                {
                    pic : banner,
                    path : 'scope'
                },
            ],
            contentFixed : false,
            fixedTop : 0,
            active : '0',
            scrollFlag: false,
            scrollTrue:false,
            choseScroll : true,
            specificationsShow : false,
            detail : {},
            specificationList: [{
                salesNumber : 0,
                curingServiceImagesBoList : [{pic:""}],
                groupActivityBo : {}
            }],
            selectSpecificationIndex : 0,
            bagitNum : {
                buyQuantity : ''
            },
            servceNum : 1,
            canTeam : true,
            canTeamMes : '',
            domArr : [],
            topArrs : [],
            isTis:true,
            hideHeaderCom: hideHeaderCom
        }
        },
        computed: {
        
        },
        created() {
            this.getHomeList();
            this.getGoodsBag();
            zhugeObj.track({
                title: "自选下单页曝光",
            });
        },
        mounted(){
            if(localStorage.isKeFuShow){
                this.isTis = false
                setTimeout(()=>{
                $(window).bind('scroll',()=>{
                    this.menu()
                });
                },1000)
            }else{
                setTimeout(()=>{
                $(window).bind('scroll',()=>{
                    this.menu()
                });
                localStorage.isKeFuShow = 1
                },4000)
            }

            let _this = this;
            getWXConfig()
        },
        beforeDestroy(){
            $(window).unbind('scroll');
        },  
        methods: {
             menu() {
                let _this = this;
                this.scrollFlag = true;
                if (timerout) {
                    window.clearTimeout(timerout);
                }
                timerout = window.setTimeout(() => {
                    this.scrollFlag = false
                }, 500);
            },
            toScope(){
                zhugeObj.track({
                    title : '自选下单-服务列表-养护类型',
                    content : {
                        '服务范围' : '点击服务范围'
                    }
                })
                this.$router.push({name:'scope'});
            },
            toHomebag(index){
                if(index == 1){
                    zhugeObj.track({
                        title : '点击-服务列表方案'
                    })
                }else if(index == 2){
                    zhugeObj.track({
                        title : '进入购物袋',
                        content : {
                            '位置' : '列表-右',
                        }
                    })
                }else{
                    zhugeObj.track({
                        title : '进入购物袋',
                        content : {
                            '位置' : '列表-内',
                        }
                    })
                }
               
             
                this.$router.push({name:"homeBag"});
            },
            
            enoughBuy(){
                this.$router.push({name:'homeBag',query:{curingServiceId:this.specificationList[this.selectSpecificationIndex].id,buyQuantity:this.servceNum}})
            },
            async addBag(){
                if(!this.canTeam){
                    Toast(this.canTeamMes);
                    return;
                }
                if(!this.servceNum){
                    Toast('请选择数量');
                    return;
                }
                let params = {
                    curingServiceId : this.specificationList[this.selectSpecificationIndex].id,
                    buyQuantity : this.servceNum,
                    curingServiceGoodsId : this.detail.id,
                    categoryId : this.detail.categoryId
                }
                if(this.specificationList[this.selectSpecificationIndex].classify == 20){
                    let paramsActive = {
                        remarks : '',
                        action : 'normal',
                        categoryRemark : '[{"id":3,"count":0},{"id":4,"count":0},{"id":5,"count":0},{"id":6,"count":0},{"id":87,"count":1}]',

                    };
                    
                    paramsActive.curingServiceId = this.specificationList[this.selectSpecificationIndex].id;
                    paramsActive.buyQuantity = this.servceNum;
                    homeApi.submitCart(paramsActive).then((res)=>{
                    
                        this.$router.push({name:'pay',query:{id:res.orderCode,type:'active'}})
                   
                    })
                    return;
                }
               

                if(this.specificationList[this.selectSpecificationIndex].classify == 30){
                    zhugeObj.track({
                        title : '自选下单——发起拼团',
                        content : {
                            '位置' : '服务列表页'
                        }
                    })
                    let params1 = {
                        action : 'normal'
                    }
                    params1.curingServiceId = this.specificationList[this.selectSpecificationIndex].id;
                    params1.buyQuantity = this.servceNum;
    

                    let tag = await publicObj.validationTeam(params1);
                    if(!tag){
                        return;
                    }
                    this.$router.push({name:'homeBag',query:{curingServiceId:this.specificationList[this.selectSpecificationIndex].id,buyQuantity:this.servceNum,isTeam:'1'}})
                    return;
                }
                
                zhugeObj.track({
                    title : '自选下单-加入方案',
                    content : {
                        '服务项ID' : params.curingServiceId,
                        '数量' : params.buyQuantity
                    }
                })
                // this.$router.push({name:'homeListNew'})

                homeApi.shoppingCart(params).then((res)=>{
                    this.bagitNum = res;
                    this.specificationsShow = false;
                })
                
            },
            setIndex(index){
                this.selectSpecificationIndex = index;
            },
            teamOpenVerify(cid){
                homeApi.teamOpenVerify(cid).then((res)=>{
                
                }).catch((data)=>{
                    this.canTeam = false;
                    this.canTeamMes = data.message
                })
            },
            select(item){
             
                if(item.groupMemberNum){
                    this.showGroupMemberNum = item.groupMemberNum;

                
                }else{
                  
                    this.canTeamMes = '';
                    this.canTeam = true;
                  
                    this.showGroupMemberNum = '';
                }
                //验证是否登录
                let tag = publicObj.validationLogin();
                if(!tag){
                    sessionStorage.setItem('url', location.href)
                    this.$store.commit('token', '');
                    localStorage.clear();
                    location.replace(location.origin + '/login');
                }
                
                this.selectSpecificationIndex = 0;
                this.servceNum = 1;
                homeApi.serviceDetail(item.id).then((res)=>{
                    if(item.groupMemberNum){
                        this.teamOpenVerify(res.curingServiceWithContentAndImagesBoList[0].id);
                    }
                    this.detail = res;
                    zhugeObj.track({
                        title : '自选下单-服务列表—+按钮',
                        content : {
                            '服务项' : res.name
                        }
                    })
                    this.specificationList = res.curingServiceWithContentAndImagesBoList;
                    this.specificationsShow = true;
                })
            },
            getGoodsBag(){
                homeApi.shoppingCartcount().then((res)=>{
                    this.bagitNum = res;
                })
            },
            scroll(){
                
                let _this = this;
                if($(window).scrollTop() > 110){
                    _this.contentFixed = true;
                }else{
                    _this.contentFixed = false;
                }
    
                if(!this.choseScroll){
                    return;
                }
                
                let windowTop = $(window).scrollTop();
                
                if(!this.topArrs.length){
                    this.domArr.forEach((item,index)=>{
                        // this.topArrs = [];
                        let top = _this.$refs[item][0].offsetTop-50;
                        this.topArrs.push(top);
                    })
                    console.log(this.topArrs)
                }else{
                    this.topArrs.forEach((item,index)=>{
                        if(this.topArrs[index + 1]){
                            if(windowTop>item && windowTop < this.topArrs[index + 1]){
                                _this.active = index
                            }   
                        }else{
                            if(windowTop > this.topArrs[this.topArrs.length - 1]){
                                _this.active = this.topArrs.length - 1
                            } 
                        }
                        
                    })
                }

               
            },
            back(){
                this.$router.back();
            },
            clickTab(index){
                console.log(index,this.serviceList[index].showFrontDeskClassify);
                zhugeObj.track({
                    title : '点击-服务类型',
                    content : {
                        '服务类型名称' : this.serviceList[index].showFrontDeskClassify
                    }
                })
                let _this = this;
                this.choseScroll = false;

                this.active = index;
                let currentY = document.documentElement.scrollTop;
                let top = this.$refs[index + 'list'][0].offsetTop - 50;
                
                scrollAnimation(currentY, top,()=>{
                    setTimeout(()=>{
                        _this.choseScroll = true;
                    },2000)
                });
            },
            getHomeList(){
                let _this = this;
                let params = {
                    current : 1,
                    size : 20000,
                }
                homeApi.curingServiceGoods(params).then((res)=>{
                    this.serviceList = res;
                    this.serviceList.forEach((item,index)=>{
                  
                        this.domArr.push(index + 'list')
                    })
                    
                    $(window).bind('scroll',function(){
                        _this.scroll();
                        if(localStorage.isKeFuShow){
                            _this.isTis = false
                            setTimeout(()=>{
                                _this.menu()
                            },1000)
                        }else{
                            setTimeout(()=>{
                                _this.menu()
                                localStorage.isKeFuShow = 1
                            },4000)
                        }
                    });
                    
                    setTimeout(()=>{
                        let active = this.$route.query.type;
                        if(active === 0){
                            this.clickTab(active);
                        }else if(active){
                            this.clickTab(active);
                        }
                    },50)
                })
            },
        }
    }
</script>


<style scoped lang="scss">
    .kefu-fix{
        width:500px;
        height:150px;
        // background-color: #7ADFDF;
        position: fixed;
        right: 0;
        bottom: 200px;
        right: 12px !important;
        transition: all 0.5s ease;
        -webkit-transition: all 0.5s ease;
    }
    .asc-line{
        width:0;
        height:60px;
        position:relative;
        background:#000000;
        color:#fff;
        white-space: nowrap;
        overflow: hidden;
        top: -14px;
        line-height: 60px;
        text-align: center;
        border-top-left-radius:25px;
        border-bottom-right-radius:25px;
        border-bottom-left-radius:25px;
    }
    .kefu-dis{
        animation:myfirst 3s;
        animation-delay:1s;
    }
    .kefu-ad{
        animation:mytwo .5s;
    }
    .kefu-baoblack{
        animation:mythree 1s;
    }
    @keyframes myfirst
    {
        0%   {left:385px;width:0}
        20%   {left:0px;width:384px}
        80%  {left:0px;width:384px}
        100%  {left:385px;width:0}
    }
    @keyframes mytwo
    {
        from {transform:scale(.1);}
        to {transform:scale(1);}
    }
    @keyframes mythree
    {
        0%   {margin-top: 48px}
        90%  {margin-top: 10px}
    }
    .scrolling {
        right: -62px !important;
        transition: all 0.5s ease;
        -webkit-transition: all 0.5s ease;
    }
    .disableBtn{
        background: #CCCCCC!important;
        color: #fff!important;
    }
    .teamTips{
        display: block;
        position: absolute;
        top:0;
        // width: 90px;
        padding:0px 10px;
        height: 32px;
        border-radius:4px;
        font-size: 20px;
        background: #6AA0A4;
        text-align: center;
        line-height: 32px;
        color:#fff;
        left:0;
    }
    .num0{
        margin-bottom: 40px;
        border-bottom: 1px solid rgba(217,217,217,0.46);
        padding-bottom: 40px;
    }
    .flex_end{
        justify-content: flex-end;
        margin-right: 0px!important;
    }
    .layer{
        padding-bottom: 100px;
    }
    .specification{
        padding:0px 0 160px 0px ;
        // border-bottom:20px #F6F6F6 solid;
        max-height: 400px;
        overflow: scroll;
        div{
            line-height: 54px;
        }
        ul{
            display: flex;
            flex-wrap: wrap;
        li{
            min-width:138px;
            height:54px;
            line-height: 52px;
            box-sizing: border-box;
            padding: 0 20px;
            background:#f8f8f8;
            border-radius:6px;
            border:$base-border;
            text-align: center;
            margin: 0 20px 20px 0;
            font-size: 22px;

        }
        .active{
            border-color: $brand-color;
            color: #000;
            background: rgba($brand-color,.1);
        }
        }
    }
    .detail_title{
        color:#333;
        font-size: 32px;
        margin-top: 40px;
        margin-bottom: 32px;
        font-weight: 500;
    }
    .detail_content{
        display:flex;
        padding-bottom: 40px;
        border-bottom:1px solid #EfEfEf;
        position: relative;
        &>div{
            width: 100%;
            flex:1;
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .detail_price{
                color:#F24949;
                font-size: 36px;
                font-weight:500;
                line-height: 55px;
            }
            .detail_sail{
                color:#999999;
                font-size: 24px;
                margin-top: 22px;
            }
        }
        .fr{
            display: flex;
            justify-content: flex-end;
        }
    }
    .detail_img{
        width: 240px;
        height: 240px;
        border-radius:12px;
        border:1px solid #6aa0a4;
    }
    .containerExpree{
        min-height: 380px;
        padding: 30px;
        position: relative;
        .title{
            line-height: 40px;
            margin-bottom: 32px;
            font-size:32px; 
            font-weight: 500;
        }
        .close{
            width: 36px;
            height: 36px;
            position: absolute;
            top: 30px;
            right: 30px;
            background: url("/images/public/close.png") no-repeat center;
            background-size: 32px;
        }
    }
    .pdb{
        padding-bottom: 150px;
    }
    .active{
        background: #fff!important;
        span{
            display: block!important;
        }
    }
    .fixed{
        position: fixed;
        top:110px;
        z-index: 999;
        height: 100%;
        overflow-y: scroll;
    }
    .fixed-top0 {
        position: fixed;
        top: 0;
        z-index: 999;
        height: 100%;
        overflow-y: scroll;
    }
    .bagit_cont{
        position: relative;
    }
    .bagit{
        width: 30px;
        height: 30px;
        display: block;
        position:absolute;
        z-index: 99;
        background: #F24949;
        color:#fff;
        border-radius:50%;
        top:2px;
        right: -10px; 
        line-height: 30px;
        text-align: center;
    }
    .g-fixed-bottom{
        display: flex;
        justify-content: space-between;
        align-items:center;
        padding-top: 0;
        z-index: 999;
            >div{
                // width: 80px;
                margin-right: 10px;
                text-align: center;
                display: flex;
               
                .price{
                    color:#F24949;
                    line-height: 80px;
                    margin-left: 30px;
                    font-size: 32px;
                    font-weight: 500;
                }

            img{
                width: 52px;
                margin-bottom: 6px;
            }
            p{
                line-height: 28px;
                font-size: 20px;
            }
            .secondary{
                margin-right: 10px;
                margin-top: 3px;
            }
        }
    }
    .headerCom{
        background: #fff;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        width: 100%;
        height: 60px;
        -webkit-transform: translateZ(0);
        padding-bottom: 20px;
        padding-top: 20px;
        .back{
            width: 60px;
            position: absolute;
            left: 30px;
            top:20px
        }
    }
    .home-list{
        display: flex;
        align-items: center;
        flex-direction: column;

    }
    .swiper{
        margin-top:110px;
        width: 690px;
        height: 200px;
        position: relative;
        z-index: 10;
        img{
            width: 100%;
        }
        &.mgt20 {
            margin-top: 20px;
        }
    }
    .location{
        position: absolute;
        left: 132px;
        height: 60px;
        display: flex;
        align-items: center;
        img{
            width: 46px;
            height: 44px;
            object-fit: cover;
            margin-right: 14px;
        }
    }
    .ml186{
        margin-left: 180px!important;
    }
    .service_list{
        border-top:1px solid #E9E9E9;
        display: flex;
        width:100%;
        background: #fff;
        .list_menu{
            width:166px;
            justify-items: 1;
            justify-items: stretch;
            img{
                width: 25px;
                margin-left: 10px;
            }
            ul{
                width:100%;
                li{
                    color:#666666;
                    height: 92px;
                    font-size:26px;
                    line-height:92px;
                    text-align:center;
                    background:#F8F8F8;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span{
                        position: absolute;
                        width: 8px;
                        height: 32px;
                        background: #7ADFDF;
                        left:12px;
                        top:30px;
                        display: none;
                    }
                }
            }
        }
        .list_content{
            // padding-left: 20px;
            // padding-right: 20px;
            margin-left: 20px;
            padding-right:30px;
            padding-bottom: 300px;
        }
        .list_title{
            height: 92px;
            line-height: 92px;
            font-size: 28px;
        }
    }
</style>
<style lang="scss">
  .van-list__finished-text, .van-list__loading-text{
    width: 100%;
  }
</style>
